module.exports = __webpack_public_path__ + "static/media/IIMSScreenLoadingAnimIcon.a606588e.gif";